import { gql } from "@apollo/client";
import { insuranceData } from "features/insuranceDocument/queries/fragments";
import { documentHeader } from "features/insuranceDocument/queries/fragments";

export const ACTIVITY_TYPES_QUERY = gql`
  query activityTypes {
    activityTypes {
      id
      code
      name
    }
  }
`;

export const INSURANCE_TYPES_QUERY = gql`
  query insuranceTypes($onlyActive: Boolean = false) {
    insuranceTypes(onlyActive: $onlyActive) {
      id
      code
      name
      implicit
    }
  }
`;

export const FINANCING_TYPES_QUERY = gql`
  query financingTypes {
    financingTypes {
      name
    }
  }
`;

export const DOCUMENT_STATES_QUERY = gql`
  query documentStates {
    documentStates {
      id
      code
      name
      implicit
    }
  }
`;

export const DOCUMENT_ALLOWED_TRANSITIONS_QUERY = gql`
  query documentAllowedTransitions($documentStateId: Int!, $documentTypeId: Int!) {
    documentAllowedTransitions(documentStateId: $documentStateId, documentTypeId: $documentTypeId) {
      documentStateId
      documentTypeId
      allowedTransitions {
        id
        code
        name
        documentTypeId
        requestComment
        commentIsMandatory
        requestReason
      }
    }
  }
`;

export const INSURANCE_DATA_QUERY = gql`
  query insuranceData($documentId: Int!) {
    insuranceData(documentId: $documentId) {
      ...insuranceData
    }
  }
  ${insuranceData}
`;

export const INSURANCE_QUOTATIONS_DATA_QUERY = gql`
  query insuranceData($documentId: Int!) {
    insuranceData(documentId: $documentId) {
      documentId
      insuranceTypeId
      offerTypeId
      currencyId
    }
  }
`;

export const INSURANCE_DATA_EXCHANGE_QUERY = gql`
  {
    insuranceDataExchange @client {
      documentsSteps
    }
  }
`;

export const DOCUMENT_HEADER_QUERY = gql`
  query documentHeader($documentId: Int!) {
    documentHeader(documentId: $documentId) {
      ...documentHeader
    }
  }
  ${documentHeader}
`;

export const QUOTATIONS_STATUS = gql`
  query quotationsStatus($documentId: Int!) {
    quotationsStatus(documentId: $documentId)
  }
`;

export const CURRENCY_QUERY = gql`
  query currencies {
    currencies {
      id
      code
      implicit
    }
  }
`;

export const PROPERTY_DETAILS = gql`
  query propertyDetails($propertyId: Int!) {
    propertyDetails(propertyId: $propertyId) {
      value
    }
  }
`;

export const VISIBILITY_LEVELS_QUERY = gql`
  query visibilityLevels {
    visibilityLevels {
      id
      name
    }
  }
`;
